import type { PlatformUpdate, MonthGroup } from '../types/updates';

function getMonthLabel(date: Date): string {
  const month = date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
  const year = date.toLocaleString('en-US', { year: 'numeric', timeZone: 'UTC' });
  return `${month} ${year}`;
}

export function groupByMonth(updates: PlatformUpdate[]): MonthGroup[] {
  const map = new Map<string, { label: string; updates: PlatformUpdate[] }>();

  for (const update of updates) {
    const label = getMonthLabel(update.publishedAt);

    if (!map.has(label)) {
      map.set(label, { label, updates: [] });
    }
    map.get(label)!.updates.push(update);
  }

  const groups = Array.from(map.values());

  groups.sort((a, b) => {
    const dateA = a.updates[0].publishedAt.getTime();
    const dateB = b.updates[0].publishedAt.getTime();
    return dateB - dateA;
  });

  for (const group of groups) {
    group.updates.sort((a, b) => b.publishedAt.getTime() - a.publishedAt.getTime());
  }

  return groups;
}
